import { Box, CircularProgress, IconButton, SxProps, Tooltip, useTheme } from '@mui/material';

import path from 'lodash/fp/path';

import { IconConfig } from '../../../types';
import { styles } from '../styles';

const DefaultIconWithLoader = ({ Icon, isLoading, disabled = false, onClick, color, tooltip, sx = {} }: IconConfig) => {
  const theme = useTheme();
  const themeColor = color ? path(['palette', color, 'main'], theme) : undefined;

  if (!Icon) return null;

  return (
    <Tooltip title={tooltip} arrow>
      <Box component="span">
        <IconButton
          onClick={onClick}
          disabled={disabled}
          aria-label={tooltip ?? 'Action'}
          sx={{ ...styles.container, ...sx } as SxProps}
        >
          <Icon sx={styles.icon(disabled ? 'action.disabled' : themeColor)} />
          {isLoading && <CircularProgress aria-label="Loading..." />}
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default DefaultIconWithLoader;
